export default __webpack_public_path__ + "static/media/lamp.021ad376.png";